import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "custom-select-wrapper" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  value: ""
}
const _hoisted_4 = ["value"]



interface Option {
  label: string;
  value: string | number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSelect',
  props: {
    modelValue: {},
    options: {},
    placeholder: { default: 'All Games' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  emit("update:modelValue", target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      value: _ctx.modelValue,
      class: "custom-select",
      onChange: handleChange
    }, [
      (_ctx.placeholder)
        ? (_openBlock(), _createElementBlock("option", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_2)
  ]))
}
}

})